import type { BaseComponentProps } from '@coursera/cds-common';
import { useLocalizedStringFormatter } from '@coursera/cds-common';
import { VideoIcon } from '@coursera/cds-icons';

import { useCardContext } from '@core/cards/common/CardContext';
import { classes } from '@core/cards/common/getCommonCardCss';
import i18nMessages from '@core/cards/common/i18n';
import Typography from '@core/Typography2';

export type CardWatchNowProps = {
  viewCount?: string;
};

type Props = {
  watchNow: CardWatchNowProps;
} & BaseComponentProps<'div'>;

/**
 * Common component to render Clips cards
 */
const CardWatchNow = ({ watchNow, ...rest }: Props) => {
  const stringFormatter = useLocalizedStringFormatter(i18nMessages);

  const context = useCardContext();
  const isCompact = context?.isCompactStyle;

  const typographyVariant = isCompact ? 'bodyTertiary' : 'bodySecondary';

  return (
    <div className={classes.watchNow} {...rest}>
      <Typography
        className={classes.watchNowIconLabel}
        component="p"
        variant={typographyVariant}
      >
        <VideoIcon className={classes.icon} size="small" />
        {stringFormatter.format('watch_now')}
      </Typography>
      <Typography color="supportText" component="p" variant={typographyVariant}>
        {'·'}
      </Typography>
      <Typography color="supportText" component="p" variant={typographyVariant}>
        {stringFormatter.format('view_count_label', {
          viewCount: watchNow.viewCount || '',
        })}
      </Typography>
    </div>
  );
};

export default CardWatchNow;
